<template>
  <div class="detail-box">
    <div v-if="!lineLoading">
      <van-nav-bar
        class="nav_bar"
        left-arrow
        right-arrow
        @click-left="backToLast"
      >
        <template #left>
          <img
            style="width: 18.44px; height: 17.35px"
            src="@/assets/home/white_back.png"
          />
        </template>
        <template #right v-if="showShareArrow">
          <img
            class="shareImg"
            src="@/assets/home/product_detail/share_icon.png"
            @click="shareClick(false)"
          />
        </template>
      </van-nav-bar>
      <!-- <img class="topImg" src="" /> -->
      <div class="header-box">
        <van-swipe class="topImg" :autoplay="3000">
          <van-swipe-item v-for="(image, index) in bannerList" :key="index">
            <img class="topImg_img" :src="getFilePath(image.filePath)" />
          </van-swipe-item>
        </van-swipe>
        <market-skill-info-bar :activityInfo="seckillActivityInfo">
        </market-skill-info-bar>
      </div>
      <!-- <div class="discount_bottom"></div> -->
      <div class="view_info">
        <div class="view_name_box">
          <div class="view_name"><span class="global-tag" v-if="lineData.globalFlag === '1'">云仓</span><span>{{ lineData.productName }}</span></div>
          <!-- <div
            v-if="!identityDeal && lineData.productName"
            class="share_btn"
            @click="sharePay"
          >
            分享代付
          </div> -->
        </div>
        <div class="view_detail">目的地：{{ endList }}</div>
        <div
        class="view_detail"
        v-if="lineData.tripTraffic && lineData.returnTraffic"
        >
        往返交通：{{ lineData.tripTraffic }}-{{ lineData.returnTraffic }}
      </div>
      <div class="view_detail">
        游玩时间：{{ lineData.playDays }}天{{ lineData.playNight }}晚
      </div>
      <!-- <div class="view_detail">产品编号：{{ lineData.productCode }}</div> -->
      <div class="view_detail">产品编号：{{ productCode }}</div>

        <!-- <div class="view_price">
          <span class="price">¥ {{ priceData.price }}</span>
          <span class="price-unit" v-if="priceData.minPrice">起</span>
          <span v-if="isGlobalEntrepot == '1'" class="is-global">云仓</span>
          <span
            v-if="couponShow"
            class="coupons-text"
            @click="showCouponCardClick"
          >
            领取优惠券
          </span>
        </div> -->
        <!-- 价格日历 -->
        <div class="view_packages">
          <!-- <div class="view_pack_title">选择套餐/日期</div> -->
          <div class="view_pack_date">
            <div class="view_pack">
              <div class="sub_title">
                选择套餐 · {{ startCityName }}出发
                <span @click="startCityShow = true" class="title_tips" v-if="startCityList.length > 1">更换出发地</span>
              </div>
              <van-swipe :loop="false" :width="140" :show-indicators="false" :initial-swipe="0">
                <van-swipe-item 
                  v-for="item in packageList" 
                  :key="item.menuId" 
                >
                  <div 
                    class="pack-item"
                    :class="{ 'isSelect': currentPackageId === item.menuId }"
                    @click="handleSelectPack(item)"
                  >
                    <div :style="{ fontSize: item.menuName.length > 9 ? '12px' : '14px'}" class="pack-text">
                      {{ item.menuName }}
                    </div>
                  </div>
                </van-swipe-item>
              </van-swipe>
            </div>
            <div class="view_date">
              <div class="sub_title">选择日期</div>
              <div class="top_date_box">
                <van-swipe :loop="false" :width="90" :show-indicators="false" ref="dateList" style="flex:1">
                  <van-swipe-item 
                    v-for="(item,index) in calendarList" 
                    :key="item.schedule" 
                  >
                    <div 
                      class="top_date_left_item"
                      :class="{ 'dateBoxActive': formattedSelectedDate === item.schedule }"
                      @click="selectDate(item)"
                    >
                      <div
                        class="date_date"
                        :key="`${item.schedule}${index}`"
                        :class="{ 'dateActive': formattedSelectedDate === item.schedule }"
                        >
                        <div style="font-weight:500">{{item.scheduledate}}</div>
                      </div>
                      <div
                        class="date_price"
                        :key="item.inventoryId"
                        :class="{ 'dateActive': formattedSelectedDate === item.schedule}"
                      >
                        <span>¥</span>
                        <span v-if="identityDeal">{{ item.priceList[0].marketPrice }}</span>
                        <span v-else>{{ item.priceList[0].distributionPrice }}</span>
                      </div>
                    </div>
                  </van-swipe-item>
                </van-swipe>
                <div class="top_date_right_box" @click="showMoreCalendar">
                  <div>
                    更多
                  </div>
                  <img
                    class="top_date_right_img"
                    src="@/assets/home/product_detail/blue_right_icon.png"
                  />
                </div>
              </div>
              
            </div>
          </div>
        </div>

      </div>
      

      <!-- <div v-if="marketType === 4">
        <div class="active-product-box" v-if="seckillActivityInfos.length">
          <common-title title="线路秒杀" :hiddenBottomLine="true"></common-title>
          <div class="active-product-item">
            <div
              class="active-product-item-cell"
              v-for="(item, index) in seckillActivityInfos"
              :key="index + 'r'"
            >
              <div class="active-product-name-box">
                <div class="active-product-name">
                  {{ lineData.productName }}
                </div>
                <div class="orderBtn" @click="toActiveOrder(item)">
                  秒杀
                </div>
              </div>
              <div class="active-product-price-box">
                <div class="active-product-active-price">
                  活动价：¥{{ item.activityPrice }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="active-product-box" v-if="regimentActivityInfos.length">
          <common-title title="线路拼团" :hiddenBottomLine="true"></common-title>
          <div class="active-product-item">
            <div
              class="active-product-item-cell"
              v-for="(item, index) in regimentActivityInfos"
              :key="index + 'r'"
            >
              <div class="active-product-name-box">
                <div class="active-product-name">
                  {{ lineData.productName }}
                </div>
                <div class="orderBtn" @click="regimentOrder(item)">
                  拼团
                </div>
              </div>
              <div class="active-product-price-box">
                <div class="active-product-active-price">
                  活动价：¥{{ item.activityPrice }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="active-product-box" v-if="bargainActivityInfos.length">
          <common-title title="线路砍价" :hiddenBottomLine="true"></common-title>
          <div class="active-product-item">
            <div
              class="active-product-item-cell"
              v-for="(item, index) in bargainActivityInfos"
              :key="index + 'b'"
            >
              <div class="active-product-name-box">
                <div class="active-product-name">
                  {{ lineData.productName }}
                </div>
                <div class="orderBtn" @click="toActiveOrder(item)">
                  砍价
                </div>
              </div>
              <div class="active-product-price-box">
                <div class="active-product-active-price">
                  活动价：¥{{ item.activityPrice }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <van-tabs class="content_box" scrollspy sticky v-model="activeName">
        <van-tab title="行程介绍" name="0">
          <common-title title="行程介绍" :hiddenBottomLine="true"></common-title>
          <TripList :tripList="productTrips" />
        </van-tab>
        <van-tab
          title="费用说明"
          name="1"
          v-if="
            lineData.expenseDescription ||
              lineData.expenseDescriptionExclusive
          "
        >
          <common-title title="费用说明" :hiddenBottomLine="true"></common-title>
          <CostDescription :expenseDescription="lineData.expenseDescription" :expenseDescriptionExclusive="lineData.expenseDescriptionExclusive" />
        </van-tab>
        <van-tab title="预定说明" name="2">
          <common-title title="预定说明" :hiddenBottomLine="true"></common-title>
          <Explain :productDesc="productDesc" :productRules="productRules"/>
        </van-tab>
        <van-tab title="评价" name="3">
          <common-title title="评价" :hiddenBottomLine="true"></common-title>
          <ticket-comment-info
            :data="commentData"
            @toAllComment="toAllComment"
          ></ticket-comment-info>
        </van-tab>
      </van-tabs>
      <div class="bottom_box">
        <div v-if="lineData.document" class="phone_box" @click="contact">
          <img class="phone_img" src="@/assets/home/product_detail/xiazai.png" />
          <div class="phone">行程文档</div>
        </div>
        <div
          class="order_btn"
          :style="{
            opacity: requestCode == 802 || requestCode == 805 ? '0.5' : '1.0',
          }"
          @click="toOrder"
        >
          {{ orderBtnStr }}
        </div>
      </div>
    </div>
    <div class="load-box" v-if="lineLoading">
      <van-loading type="spinner" />
    </div>
    

    <!-- <van-popup
      v-model="showCouponCard"
      closeable
      title="领取优惠券"
      position="bottom"
      :style="{ height: '440px' }"
    >
      <coupons-card
        :type="3"
        :productList="[productId]"
        productType="2"
        :key="couponCardKey"
      ></coupons-card>
    </van-popup> -->

    <product-poster
      class="product-poster"
      v-if="showShare"
      :coverImage="coverImage"
      :productName="lineData.productName"
      :des="productDesc.specialService"
      :price="sharePosterInfoComputed.price"
      :sharePayFlag="sharePayFlag"
    ></product-poster>
    <van-overlay :show="showShare" z-index="99" @click="clickOverlay" />

    <!-- 2022.11.22修改分享海报 -->
    <van-overlay :show="showShareProduct" z-index="99" @click="clickOverlay">
      <div class="wrapper_box" @click.stop>
        <div class="block">
          <product-share
            class="product-share_box"
            v-if="showShareProduct"
            :coverImage="coverImage"
            :productName="lineData.productName"
            :shareUrl="shareUrl"
            :minprice="sharePrice"
            desc="长按扫码查看更多线路，行千里，看天下，游遍大好河山"
            type="线路"
          ></product-share>
        </div>
      </div>
    </van-overlay>

    <suspension-button></suspension-button>

    <van-calendar
      v-model="showCalendar"
      :default-date="selectedDate ? selectedDate.toDate() : null"
      :formatter="formatter"
      @confirm="onConfirm"
    />
    <van-action-sheet v-model="showServicePhone" class="service-dialog">
      <a :href="`tel:${ servicePhone }`" class="service-phone">{{ servicePhone }}</a>
      <div class="service-cancel" @click="showServicePhone = false">取 消</div>
    </van-action-sheet>
    <!-- 城市选择弹出层 -->
    <van-popup v-model="startCityShow" round position="bottom">
      <van-picker
        show-toolbar
        :columns="startCityList"
        @cancel="startCityShow = false"
        @confirm="confirmStartCity"
      >
        <template #option="option">
          <div>{{ option.areaName }}</div>
        </template>
      </van-picker>
    </van-popup>
  </div>
</template>

<script>
import {
  weChatUpdateAppMessageShareData,
  weChatUpdateTimelineShareData,
} from "@/lib/weixin-js-sdk";
import commonTitle from "../../../components/common_title.vue";
import { getImgUrl } from "../../../mixins/getImgUrl";
import couponsCard from "../../../components/coupons-card.vue";
import productShare from '@/new_views/activity/product-share';
import ticketCommentInfo from "@/components/ticket_comment_info.vue";
import marketSkillInfoBar from "@/components/market-skill-info-bar.vue";
import suspensionButton from "@/components/suspension-button.vue";
import TripList from "./components/line-tripList.vue";
import CostDescription from "./components/line-cost-description.vue";
import Explain from "./components/line-explain.vue";
import { Toast } from "vant";
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import { getUserQfRegisterInfo } from '@/api/user';
import dayjs from 'dayjs';
import { getContractConfig } from '@/api/v3/vacation';
export default {
  mixins: [getImgUrl],
  components: {
    commonTitle,
    couponsCard,
    productShare,
    ticketCommentInfo,
    marketSkillInfoBar,
    suspensionButton,
    TripList,
    CostDescription,
    Explain,
  },
  data() {
    return {
      // productId: "",
      // lineData: {},
      priceData: {
        price: "",
        minPrice: false,
        dealPrice: "",
      },
      // bannerImages: [],
      showCouponCard: false, // 优惠券弹窗
      couponCardKey: 1, // 每次显示都重新获取
      showShare: false, // 分享海报
      // comments: {}, //评论
      commentsList: [],
      params: {},
      seckillActivityInfo: null, // 秒杀活动
      seckillActivityInfos: [], // 秒杀活动列表
      regimentActivityInfos: [], // 平团活动列表
      bargainActivityInfos: [], // 砍价活动列表
      isCollect: false, //是否收藏
      identityDeal: false,
      sharePayFlag: false,
      marketType: 4, //营销进来的标识  1秒杀 2拼团 3砍价
      lineNewData: {}, //新的详情数据
      isGlobalEntrepot: "", //全球仓
      requestCode: 0,
      activeName: "0",
      // 行程
      tripList: [],
      // 费用说明
      // expenseDescription: {},
      // 领取优惠券
      couponShow: false,

      // 线路改造参数
      activePack: 0, // 选择的套餐
      showCalendar: false,
      showShareProduct: false, // 产品海报分享
      shareUrl: '', // 分享链接
      sharePrice: '',
      showServicePhone: false,
      servicePhone: '',
      startCityShow: false,
      productCode: ''
    };
  },
  computed: {
    ...mapState(['orgId']),
    ...mapState('vacation/detail', [
      'libId',
      'productId',
      'lineData',
      'lineLoading',
      'productDesc',
      'productTrips',
      'productRules',
      'commentData',
      'packageList',
      'calendarList',
      'selectedDate',
      'showShareArrow',
      'startCityList',
    ]),
    ...mapGetters('vacation/detail', [
      'endList',
      'bannerList',
      'coverImage',
      'formattedSelectedDate',
    ]),
    // 分享的海报数据
    sharePosterInfoComputed() {
      // const coverImage = this.getCoverImage();
      const str = this.lineData.expenseDescription?.replace(/<[^>]+>/g, "");
      let shareInfo = {
        coverImage: this.coverImage,
        productName: this.lineData.productName,
        des: str,
        price: this.priceData.dealPrice,
      };
      return shareInfo;
    },
    orderBtnStr() {
      if (this.requestCode == 802) {
        return "产品已下架";
      } else if (this.requestCode == 805) {
        return "产品无库存";
      }
      const { identityType } = this.$store.state.userInfo_v2.identity;
      if(this.lineData.salesModel === '2' && identityType === '5'){
        return '预订请咨询客服';
      }
      if (this.marketType === 1) {
        return "秒杀预定";
      } else if (this.marketType === 2) {
        return "拼团预定";
      } else if (this.marketType === 3) {
        return "砍价预定";
      }
      return "立即预定";
    },
    currentPackageId:{
      get() {
				return this.$store.state.vacation.detail.currentPackageId;
			},
			set(val) {
				this.setCurrentPackageId(val);
			}
    },
    startCityCode:{
      get() {
				return this.$store.state.vacation.detail.startCityCode;
			},
			set(val) {
				this.setStartCityCode(val);
			}
    },
    startCityName(){
      const obj = this.startCityList.find(i => i.areaCode === this.startCityCode);
      return obj ? obj.areaName : this.startCityCode;
    },
  },
  created() {
    // if (this.$route.query.psid) {
    //   sessionStorage.setItem('sharePsid', this.$route.query.psid)
    // } else {
    //   sessionStorage.setItem('sharePsid', '')
    // }
    // if (this.$route.query.sharedUserId) {
    //   sessionStorage.setItem('sharedUserId', this.$route.query.sharedUserId)
    // } else {
    //   sessionStorage.setItem('sharedUserId', '')
    // }
    const { psid, sharedUserId, libId, marketType, productCode } = this.$route.query
    sessionStorage.setItem('sharePsid', psid || '')
    sessionStorage.setItem('sharedUserId', sharedUserId || '')
    if (libId) {
      this.setLibId(libId);
      this.fetchLineData(sharedUserId ? sharedUserId : '');
    };
    if (productCode) {
      this.productCode = productCode;
    }
    // 营销进来的标识
    this.marketType = parseInt(marketType) || 4;
    this.identityDeal = this.$store.getters.identityDeal;
    // this.init();
    // this.judgeUserCollecttion();
    // // 获取产品的优惠券列表，如果没有就不展示领取优惠券
    // this.getProductCounponsList();
  },
  methods: {
    ...mapMutations('vacation/detail', [
      'setLibId',
      'setSelectedDate',
      'setCalendarList',
      'setCurrentPackageId',
      'setShowShareArrow',
      'setStartCityCode'
    ]),
    ...mapActions('vacation/detail', [
      'fetchLineData',
    ]),
    handleSelectPack(item) {
      if(this.currentPackageId === item.menuId) return;
      this.currentPackageId = item.menuId;
      let date = "";
      // 切换套餐=》选中日期变为第一个
      this.packageList.forEach(element => {
        if (element.menuId === item.menuId) {
          date = element.details[0].schedule;
          this.setSelectedDate(dayjs(date));
          this.setCalendarList(element.details);
          // 回到第1个
          this.$refs.dateList.swipeTo(0);
        }
      });
    },
    // 更多日期
    showMoreCalendar() {
      this.showCalendar = true;
      window.scrollTo(0, 0);
    },
    //自定义日历内容
    formatter(day) {
      const date = dayjs(day.date).format('YYYY-MM-DD');
      const targetSchedule = this.calendarList.find(
        (schedule) => schedule.schedule === date,
      );
      if (targetSchedule) {
        day.bottomInfo = `￥${
          this.identityDeal
            ? targetSchedule.priceList[0].marketPrice
            : targetSchedule.priceList[0].distributionPrice
        }`;
      } else {
        day.type = 'disabled';
      }
      return day;
    },

    // 选择日期
    selectDate(item) {
      this.setSelectedDate(dayjs(item.schedule));
    },

    onConfirm(date) {
      this.setSelectedDate(dayjs(date));
      const index = this.calendarList.findIndex(
        (schedule) => schedule.schedule === this.formattedSelectedDate,
      );
      this.$refs.dateList.swipeTo(index);
      this.showCalendar = false;
    },

    // toAllComment() {
    //   this.$router.push({
    //     path: "/order/orderComment",
    //     query: { data: this.params },
    //   });
    // },
    toAllComment() {
      this.$router.push({
        path: '/order/orderComment',
        query: {
          data: {
            organizationId: this.orgId,
            productId: [this.libId],
            pageSize: 1,
            currentPage: 1,
          },
        },
      });
    },
    contact() {
      window.location.href = this.lineData.document; //"tel://" + this.lineData.emergencyContact;
    },
    toOrder() {
      if (this.requestCode == 802 || this.requestCode == 805) {
        return;
      }
      const { identityType } = this.$store.state.userInfo_v2.identity;
      if(this.lineData.salesModel === '2' && identityType === '5'){
        getContractConfig().then(res => {
          if(res.data){
            const { servicePhone } = res.data;
            this.servicePhone = servicePhone;
            this.showServicePhone = true;
          } else {
            Toast('暂无客服电话，请选购其他产品！');
          }
        }).catch(() => {
          Toast('暂无客服电话，请选购其他产品！');
        })
        return;
      }
      if (this.marketType === 1) {
        this.toActiveOrder(this.seckillActivityInfos[0]);
        return;
      } else if (this.marketType === 2) {
        this.regimentOrder(this.regimentActivityInfos[0]);
        return;
      } else if (this.marketType === 3) {
        this.toActiveOrder(this.bargainActivityInfos[0]);
        return;
      }
      // 普通下单
      this.$store.commit("SET_KEEP_ALIVE", ["line_place_order"]);
      var query = {
        productName: this.lineData.productName,
        productId: this.productId,
        isGlobalEntrepot: this.isGlobalEntrepot,
        packageId: this.currentPackageId,
        selectedDate: dayjs(this.selectedDate).format('YYYY-MM-DD'),
        libId: this.lineData.libId,
        sharedUserId: this.$route.query.sharedUserId || '',
      };
      // const share = this.$route.query.shareFlag;
      // if (share === "1" && this.$store.getters.identityDeal) {
      //   query.shareFlag = true;
      //   query.shareUserId = this.$route.query.shareId;
      // }
      if (!this.selectedDate) {
        this.$toast("请选择出发日期");
        return;
      };
      this.$router.push({
        path: "/order/line_place_order",
        query: query,
      });
    },
    // 秒杀砍价下单
    toActiveOrder(e) {
      this.$store.commit("SET_KEEP_ALIVE", ["line_place_order"]);
      this.$router.push({
        path: "/order/line_place_order",
        query: {
          address: this.lineData.address,
          productName: this.lineData.productName,
          productId: this.lineData.productId,
          activityInfo: e,
          isGlobalEntrepot: this.isGlobalEntrepot,
        },
      });
    },
    // 拼团下单
    regimentOrder(e) {
      this.$router.push({
        path: "/group-buy-detail",
        query: {
          mainId: e.mainId,
          activeExtra: {
            address: this.lineData.address,
            productName: this.lineData.productName,
            isGlobalEntrepot: this.isGlobalEntrepot,
          },
        },
      });
    },
    backToLast() {
      this.$router.go(-1);
    },
    // 配置分享数据
    configureShareInfo() {
      // 微信分享  自定义“分享给朋友”及“分享到QQ”按钮的分享内容
      const url = window.location.href;
      //+ '&shareFlag=' + (shareFlag ? '1' : '0')
      console.log("分享url", url);

      weChatUpdateAppMessageShareData({
        title: this.lineData.productName, // 分享标题
        desc: "", // 分享描述
        link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: this.getFilePath(this.coverImage), // 分享图标
        success: () => {
          // 设置成功
        },
      });

      // 微信分享 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
      weChatUpdateTimelineShareData({
        title: this.lineData.productName, // 分享标题
        link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: this.getFilePath(this.coverImage), // 分享图标
        success: () => {
          // 设置成功
        },
      });
    },

    // getCoverImage() {
    //   const data = this.bannerImages
    //     .filter((res) => {
    //       return res.isPoster === "Y";
    //     })
    //     .map((res) => {
    //       return res.filePath;
    //     });
    //   return data[0] || this.bannerImages[0]?.filePath;
    // },
    sharePay() {
      this.shareClick(true);
    },
    // 点击分享
    async shareClick(flag) {
      this.sharePayFlag = flag;
      const res = await getUserQfRegisterInfo();
      if (res.code === 200) {
        // 如果未认证需要先认证
        if (res.data.authFlag == 0 && res.data.userType != 3) {
          this.$router.push('/userRegisterBefore')
        } else {
          // 不滚动到最上面，会出现生成的图片上部空白的情况
          document.body.scrollTo({
            top: 0,
          });
          // 兼容写法，两个都必须要
          document.documentElement.scrollTo({
            top: 0,
          });
          document.body.style.overflow = "hidden";
          // this.showShare = true; // 2022.11.22修改分享海报
          this.showShareProduct = true;
          if (this.selectedDate) {
            var temp = this.calendarList.filter(item => {
              return item.schedule === dayjs(this.selectedDate).format('YYYY-MM-DD')
            })
            if (temp.length > 0) {
              // this.sharePrice = this.identityDeal ? temp[0].priceList[0].marketPrice : temp[0].priceList[0].distributionPrice
              this.sharePrice = temp[0].priceList[0].marketPrice
            }
          } else {
            // this.sharePrice = this.identityDeal ? this.calendarList[0].priceList[0].marketPrice : this.calendarList[0].priceList[0].distributionPrice
            this.sharePrice = this.calendarList[0].priceList[0].marketPrice
          }
          var pathParam = window.location.href.split('?')[1];
          this.shareUrl = `/home/productDetail/line_detail?${pathParam}`;
          // console.log(this.shareUrl, '分《《《《')
          // console.log(pathParam, window.location.href, '当前地址')
          this.shareLog();
        }
      }
    },
    shareLog() {
      const userId = this.$store.state.userInfo_v2.user.userId;
      const openId = localStorage.getItem("openId");
      const data = {
        shareId: this.productId,
        openGid: openId,
        userId: userId,
      };
      this.$API.market.shareLog(data).then((res) => {});
    },
    // 点击分享遮罩层
    clickOverlay() {
      // this.showShare = false;
      this.showShareProduct = false;
      document.body.style.overflow = "auto";
    },
    // 显示优惠券
    // showCouponCardClick() {
    //   this.showCouponCard = true;
    //   this.couponCardKey++;
    // },
    // 如果优惠券为0张，就不显示领取
    // getProductCounponsList() {
    //   let param = {
    //     productIds: [this.productId],
    //     productType: "2",
    //     receiveChannel: "h5",
    //   };
    //   this.$API.coupons
    //     .selectProductCouponsList(param)
    //     .then((res) => {
    //       if (res.data.length) {
    //         this.couponShow = true;
    //       }
    //     })
    //     .catch((err) => {
    //       this.couponShow = false;
    //     });
    // },
    confirmStartCity(val){
      this.startCityShow = false;
      this.startCityCode = val.areaCode;
    },
  },
  destroyed() {
    this.setShowShareArrow(false)
  }
};
</script>

<style lang="scss" scoped>
.detail-box {
  background-color: #f4f6f9;
  height: 100%;
  // 去掉导航栏底部的一根细线
  .van-hairline--bottom:after {
    border-bottom-width: 0px;
  }
  .nav_bar {
    position: absolute;
    z-index: 98;
    top: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0);
  }
  .likeImg {
    width: vw(40);
    height: vw(36);
    margin-right: vw(50);
  }
  .shareImg {
    width: vw(49);
    height: vw(49);
  }
  .header-box {
    position: relative;
    .topImg {
      width: 100%;
      height: vw(400);
      background-color: gray;
      .topImg_img {
        width: 100%;
        height: 100%;
		object-fit: cover;
      }
    }
  }

  .discount_bottom {
    width: 100%;
    height: vw(20);
    background-color: #ffffff;
    margin-top: vw(-20);
    border-top-left-radius: vw(20);
    border-top-right-radius: vw(20);
  }
  .view_info {
    position: relative;
    margin-top: vw(-20);
    background-color: #ffffff;
    width: 100%;
    padding-bottom: vw(30);
    border-top-left-radius: vw(20);
    border-top-right-radius: vw(20);
    .view_name_box {
      display: flex;
      align-items: center;
      .view_name {
        padding-top: vw(20);
        margin-left: vw(30);
        margin-right: vw(30);
        color: #333333;
        font-size: vw(36);
        font-weight: bold;
        flex: 1;
        .global-tag {
          background-color: #00479C;
          border-radius: vw(8);
          box-sizing: border-box;
          padding: vw(8) vw(20);
          font-size: vw(28);
          color: #fff;
          margin-right: vw(8);
        }
      }
      .share_btn {
        background: linear-gradient(to right, #ff8433, #ff3530);
        padding: vw(10) vw(20);
        color: #ffffff;
        font-size: vw(30);
        font-weight: bold;
        border-radius: vw(8);
        margin-right: vw(20);
      }
    }

    .view_detail {
      margin-left: vw(30);
      margin-right: vw(30);
      padding: 4px 0;
      color: #999999;
      font-size: vw(26);
    }
    .view_tags {
      margin-left: vw(30);
      margin-right: vw(30);
      margin-top: vw(16);
      display: flex;
      flex-direction: row;
      align-items: center;
      .tag_text {
        color: #c6a753;
        font-size: vw(22);
        padding: vw(3) vw(10);
        margin-right: vw(10);
        border: vw(1) #c6a753 solid;
        border-radius: vw(3);
      }
    }
    .view_price {
      margin-left: vw(30);
      margin-top: vw(24);
      display: flex;
      flex-direction: row;
      align-items: center;
      .price {
        font-size: vw(26);
        color: #ff1414;
      }
      .price-unit {
        margin-left: 2px;
        color: #666666;
        font-size: vw(26);
      }
      .is-global {
        margin-left: vw(15);
        background-color: #ff1414;
        color: #ffffff;
        font-size: vw(20);
        font-weight: bold;
        padding: vw(5) vw(17);
        border-radius: vw(3);
      }
    }
    .view_send {
      height: vw(68);
      margin-left: vw(30);
      margin-right: vw(30);
      margin-top: vw(35);
      border-radius: vw(8);
      background-color: #fdf7f1;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      .view_send_left {
        margin-left: vw(32);
        display: flex;
        flex-direction: row;
        align-items: center;
        .view_send_img {
          width: vw(38);
          height: vw(38);
          background-color: red;
        }
        .view_send_text {
          margin-left: vw(22);
          color: #ff9321;
          font-size: vw(26);
        }
      }
      .view_send_right {
        color: #ff9321;
        font-size: vw(26);
        margin-right: vw(32);
      }
    }
  }
  .content_box {
    padding-bottom: vw(140);
    margin-top: vw(30);
    background-color: #ffffff;

    .route_list {
      margin-left: vw(30);
      margin-right: vw(30);
      font-size: vw(28);
      color: #333333;
    }
    .fee_construct {
      margin: vw(0) vw(30) vw(20) vw(30);
      color: #333333;
      font-size: vw(28);
    }
    .img_construct {
      margin-left: vw(30);
      margin-right: vw(30);
      width: vw(690);
      height: vw(305);
      background-color: red;
    }
  }
  .detail_content_box {
    margin-top: vw(21);
    background-color: #ffffff;
    .menu_box {
      height: vw(78);
      border-bottom: vw(1) #eef0f3 solid;
      background-color: #ffffff;
      display: flex;
      flex-direction: row;
      justify-content: space-evenly;
      align-items: center;
      .menu_item {
        height: 100%;
        width: vw(60);
        position: relative;
        .menuText {
          height: vw(42);
          margin-top: vw(18);
          color: #333333;
          font-size: vw(28);
        }
        .menuTextActive {
          font-size: vw(30);
          color: $theme-color;
        }
        .menuLine {
          background-color: $theme-color;
          border-radius: vw(4);
          height: vw(6);
          width: vw(36);
          position: absolute;
          bottom: 0;
          left: vw(12);
        }
      }
    }
  }
  .bottom_box {
    background-color: #ffffff;
    padding-bottom: vw(20);
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    height: vw(104);
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    .phone_box {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      .phone_img {
        width: vw(45);
        height: vw(45);
        object-fit: contain;
      }
      .phone {
        text-align: center;
        font-size: vw(29);
        font-weight: bold;
        color: #2e3033;
      }
    }
    .order_btn {
      background: linear-gradient(to right, #ff8433, #ff3530);
      height: vw(80);
      width: vw(470);
      color: #ffffff;
      font-size: vw(30);
      font-weight: bold;
      text-align: center;
      line-height: vw(80);
      border-radius: vw(8);
    }
  }
  .coupons-text {
    background-color: #fff1e2;
    color: #ff8000;
    font-size: 13px;
    padding: 3px 8px;
    margin-left: 4px;
    border-radius: 2px;
  }

  .product-poster {
    position: fixed;
    top: 8%;
    left: 20px;
    right: 20px;
    z-index: 100;
  }
  .wrapper_box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: vw(40);
    .block {
      width: vw(660);
      height: vw(1100);
      // border-radius: vw(12);
    }
  }
  .active-product-box {
    .active-product-item {
      margin-left: vw(30);
      margin-right: vw(30);
      background-color: white;
      border-radius: vw(10);
      padding-top: vw(20);
      padding-bottom: vw(20);
      .active-product-item-cell {
        padding: vw(10) vw(30);
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        font-size: vw(26);
        .active-product-name-box {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          .active-product-name {
            color: #333333;
          }
          .orderBtn {
            padding-left: vw(10);
            padding-right: vw(10);
            padding-top: vw(6);
            padding-bottom: vw(6);
            color: #ffffff;
            border-radius: vw(5);
            background: linear-gradient(to right, #ff8d33, #ff3030);
          }
        }
        .active-product-price-box {
          margin-top: vw(15);
          display: flex;
          flex-direction: row;
          align-items: center;
          .active-product-active-price {
            color: #333333;
          }
        }
      }
    }
  }
  .share-indor {
    width: vw(523);
    height: vw(154);
    float: right;
    margin-right: 10px;
  }
  .view_packages {
    // background: #F1F7FE;
    padding: vw(30);
    // margin-top: vw(20);
    .view_pack_title {
      color: #0051AB;
      font-weight: 500;
      font-size: vw(30);
    }
    .view_pack_date {
      margin-top: vw(10);
      border-radius: vw(18);
      // border: 1px solid #0051AB;
      // padding: vw(20);
      background: #fff;
      .view_pack {
        .sub_title {
          font-size:vw(30);
          font-weight: 600;
          color: #333333;
          margin-bottom: vw(16);
          .title_tips {
            color: #00479C;
            font-size: 12px;
            font-weight: 500;
            margin-left: vw(30);
          }
        }
      }
      .view_date {
        .sub_title {
          font-size:vw(30);
          font-weight: 600;
          color: #333333;
          margin-bottom: vw(10);
          margin-top: vw(30);
        }
        .top_date_box {
          margin-top: vw(20);
          height: vw(150);
          display: flex;
          flex-direction: row;
          .top_date_left_item {
            height: calc(100% - 2px);
            margin-right: vw(10);
            background-color: #fcfdff;
            border-radius: vw(8);
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            border: 1px solid #fff;
            .date_date {
              margin-bottom: vw(3);
              width: vw(160);
              color: #666666;
              font-size: vw(30);
              text-align: center;
              font-weight: 500;
              color: #333333;
            }
            .date_price {
              margin-top: vw(3);
              color: #333333;
              font-size: vw(32);
              span {
                display: inline-block;
                margin-top: vw(10);
                font-size: vw(32);
                color: #00479C;
              }
            }
            .dateActive {
              color: #00479C;
            }
          }
          .dateBoxActive {
            border: 1px solid #00479C;
            background-size: 100% 100%;
          }
          .top_date_right_box {
            width: vw(70);
            color: $theme-color;
            font-size: vw(22);
            margin-left: vw(10);
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            .top_date_right_img {
              width: vw(22);
              height: vw(21);
            }
          }
        }
      }
    }
  }
  .load-box {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .service-dialog {
    background-color: transparent;
    .service-phone {
      display: block;
      width: 90%;
      padding: 20px 0;
      font-size: 16px;
      text-align: center;
      color: #016ae7;
      background-color: #fff;
      border: none;
      cursor: pointer;
      margin: 0 auto;
      border-radius: 16px;
    }
    .service-cancel {
      width: 90%;
      padding: 20px 0;
      font-size: 16px;
      text-align: center;
      color: #016ae7;
      background-color: #fff;
      border: none;
      cursor: pointer;
      margin: 20px auto;
      border-radius: 16px;
      margin-bottom: 30px;
    }
  }
    .pack-item {
      display: flex;
      justify-content: center;
      align-items: center;
      // width: vw(200);
      // min-width: vw(200);
      height: vw(90);
      padding: vw(10) vw(20);
      border: 1px solid #fcfdff;
      border-radius: vw(8);
      margin-right: vw(20);
      background-color: #fcfdff;
      .pack-text {
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        line-clamp: 2;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
    .isSelect {
      color: #00479c;
      border-color: #00479c;
    }
}
</style>
